<div class="filter-for-list" *ngIf="!readOnly">
    <mat-form-field class="mini-list-header" placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
        <input matInput (keyup)="applyFilter($event.target.value)"
               [placeholder]="'SEARCH' | translate">
    </mat-form-field>
    <button  type="button" class="btn top-list-tools"
            (click)="openModal()" placement="left"
            [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
        <fa-icon [icon]="faPlus"></fa-icon>
        {{'ADD_USER'|translate}}
    </button>
    <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>
<table mat-table [dataSource]="alarmUsers" matSort class="table-striped" style="width:100%">

    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMAIL'|translate}}</th>
        <td mat-cell *matCellDef="let user"><b>{{user.email}}</b>
        </td>
    </ng-container>

    <ng-container matColumnDef="firstname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'FIRSTNAME'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.firstname}}
        </td>
    </ng-container>


    <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LASTNAME'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.lastname}}
        </td>
    </ng-container>

    <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PHONE'|translate}}</th>
        <td mat-cell *matCellDef="let user"> {{user.phone}}
        </td>
    </ng-container>
    <ng-container matColumnDef="subscription">
        <th mat-header-cell *matHeaderCellDef style="width:170px"> {{'SUBSCRIPTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let user">
            <mat-slide-toggle (change)="setSubscriptions()" style="margin:0px !important;" class="sliderActiveList" [(ngModel)]="user.send_email"
                              placement="right"
                              [ngbTooltip]="'EMAIL' | translate" [disabled]="readOnly">{{'EMAIL' | translate}}
            </mat-slide-toggle>

            <mat-slide-toggle (change)="setSubscriptions()" *ngIf="user.phone" style="margin:0px !important;" class="sliderActiveList" [(ngModel)]="user.send_sms"
                              placement="right"
                              [ngbTooltip]="'SMS' | translate" [disabled]="readOnly">{{'SMS' | translate}}
            </mat-slide-toggle>

            <mat-slide-toggle (change)="setSubscriptions()" *ngIf="user.phone" style="margin:0px !important;" class="sliderActiveList" [(ngModel)]="user.send_voice"
                              placement="right"
                              [ngbTooltip]="'VOICE' | translate" [disabled]="readOnly">{{'VOICE' | translate}}
            </mat-slide-toggle>
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="width:30px"> {{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let user">

            <mat-icon style="color:red;cursor:pointer" (click)="removeUserToProject(user)"
                      matTooltipPosition="right"
                      [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
            </mat-icon>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="5"
               *ngIf="!readOnly"></mat-paginator>
